import _ from "lodash";
import { useSelector } from "src/store";

import { Group } from "@dashboard/devices/types";
import { selectGroups } from "@dashboard/groups/store/selectors";
import { useCurrentWorkspace } from "@dashboard/workspaces/api/helpers";
import { GetWorkspacesParams } from "@dashboard/workspaces/api/rtkClient";
import { WorkspaceMember } from "@dashboard/workspaces/types";

function useGroupsAndWorkspaceMembers(options?: GetWorkspacesParams): WorkspaceMember[] {
    const groups = useSelector(selectGroups);
    const { data: workspace } = useCurrentWorkspace(options);

    const groupsMembers = groups.map((item) => item.members).flat();
    return workspace?.members ? _.uniqBy([...workspace.members, ...groupsMembers], "email") : _.uniqBy(groupsMembers, "email");
}

function useGroupsByMemberEmail(email: string): Group[] {
    const groups = useSelector(selectGroups);
    return groups.filter((group) => group.members.some((member) => member.email === email));
}

export { useGroupsAndWorkspaceMembers, useGroupsByMemberEmail };
